import script from "./Tag.vue?vue&type=script&setup=true&lang=js"
export * from "./Tag.vue?vue&type=script&setup=true&lang=js"

import "./Tag.vue?vue&type=style&index=0&id=638fa5b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-638fa5b6"]])

export default __exports__